import { useMemo } from "react";

import dayjs from "@/lib/dayjs";
import { getTodaysDate } from "@/lib/dayjs/get-todays-date";
import { isPastDate } from "@/lib/dayjs/is-past-date";

type Props = {
	validDtEndBasicInitialSetUp?: string | null;
};

export const useHandleTrial = ({ validDtEndBasicInitialSetUp }: Props) => {
	/**
	 * 本日から終了日の差分の日数
	 */
	const diffDateFromToday = useMemo(
		() => (validDtEndBasicInitialSetUp ? dayjs(validDtEndBasicInitialSetUp).diff(getTodaysDate(), "d") : 0),
		[validDtEndBasicInitialSetUp],
	);

	/**
	 * トライアルに関する期間の情報が存在しているか
	 */
	const isExistValidDtForTrial = useMemo(() => {
		//
		if (!validDtEndBasicInitialSetUp) return false;

		// 過去の日付でなければトライアル期間中
		return !isPastDate(validDtEndBasicInitialSetUp);
	}, [validDtEndBasicInitialSetUp]);
	/**
	 * トライアル期間が終了しているか
	 * 残日数が0日未満の場合は終了している
	 */
	const isFinishedTrial = useMemo(() => diffDateFromToday < 0, [diffDateFromToday]);
	/**
	 * 残日数
	 */
	const remainingDays = useMemo(() => diffDateFromToday + 1, [diffDateFromToday]);
	/**
	 * トライアル終了日のフォーマット
	 */
	const formatTrialFinishDate = useMemo(() => {
		return dayjs(validDtEndBasicInitialSetUp).format("YYYY年MM月DD日");
	}, [validDtEndBasicInitialSetUp]);

	return {
		isExistValidDtForTrial,
		isFinishedTrial,
		formatTrialFinishDate,
		remainingDays,
	};
};
